import PropTypes from "prop-types";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material";
import { Box, Typography } from "@mui/material";
import "../styles/ProgressBar.css";
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import Stack from '@mui/material/Stack';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    background:  rgba(97, 97, 97, 0.92)!important;
    color:#fff !important
  }
     & .MuiTooltip-arrow: {
    color: rgba(97, 97, 97, 0.92)!important;
  }
`;

export default function ProgressBar({ percentComplete, leftLabel, rightLabel }) {

  return (
    // display: percentComplete === 0 ? "none" : "block"
      <Box className="progress-bar" sx={{backgroundColor:"#fff" }} > 
        <Tooltip title={percentComplete + "%"} placement="top" arrow followCursor>
          <Box >
            <div className="progress mt-2" style={{ borderRadius: "0", width: "99%",height:"25px"}}>
              <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-label="Animated striped example" style={{ width: percentComplete + "%" }}><span style={{ color: "black",fontSize:"16px",padding:"15px",fontWeight:"bold",marginTop:"10px",marginBottom:"10px" }}>{percentComplete + "%"}</span></div>
            </div>
          </Box>
        </Tooltip>
        <Box className="labels">
          <Box className="label-container">
            <Typography variant="subtitle2" style={{fontSize:"inherit"}}>{leftLabel}</Typography>
          </Box>
          <Box flexGrow={1} />
          <Box className="label-container">
            <Typography variant="subtitle2">{rightLabel}</Typography>
          </Box>
        </Box>
      </Box>
      
  
  );
}

ProgressBar.propTypes = {
  /**
   * Label to show on the left side
   */
  leftLabel: PropTypes.string,
  /**
   * Label to show on the right side
   */
  rightLabel: PropTypes.string,
  /**
   * Percent of width to show as completed
   */
  percentComplete: PropTypes.number,
};
